import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["previewStatus", "playerHost"];

  connect() {
    this.statusUrl = this.element.dataset.statusUrl;
    if (!this.statusUrl) return;

    this.pollCount = 0;
    this.maxPolls = 40;
    this.pollIntervalMs = 15000;
    this.pollTimer = window.setInterval(() => this.pollStatus(), this.pollIntervalMs);
    this.pollStatus();
  }

  disconnect() {
    if (this.pollTimer) window.clearInterval(this.pollTimer);
    if (this.players) {
      this.players.forEach((player) => player.dispose && player.dispose());
    }
  }

  async pollStatus() {
    this.pollCount += 1;
    if (this.pollCount > this.maxPolls) {
      window.clearInterval(this.pollTimer);
      this.previewStatusTargets.forEach((el) => {
        el.textContent =
          "The preview is still processing. The case is already saved. Wait and play it before you remove the folder from the CMAC.";
      });
      return;
    }

    try {
      const response = await fetch(this.statusUrl, { credentials: "same-origin" });
      if (!response.ok) return;
      const payload = await response.json();
      this.renderFiles(payload.files || []);
    } catch (error) {
      console.error("upload status poll failed", error);
    }
  }

  renderFiles(files) {
    files.forEach((file) => {
      const row = this.element.querySelector(`[data-aws-video-id="${file.id}"]`);
      if (!row) return;

      const sizeEl = row.querySelector(".cmac-upload-size-check");
      if (sizeEl && file.original_size != null && file.stored_size != null) {
        const match = file.size_match ? "✓" : "✗";
        sizeEl.textContent = `${this.formatSize(file.original_size)} on the CMAC → ${this.formatSize(file.stored_size)} stored ${match}`;
      }

      if (!file.preview_ready) return;

      const statusEl = row.querySelector(".cmac-preview-status");
      if (statusEl) statusEl.textContent = "Preview ready";

      const host = row.querySelector(".cmac-preview-player");
      const videoEl = host && host.querySelector("video");
      if (!host || !videoEl || videoEl.dataset.playerReady === "true") return;

      host.hidden = false;
      videoEl.dataset.playerReady = "true";
      this.initPlayer(videoEl);
    });

    if (files.every((file) => file.preview_ready)) {
      window.clearInterval(this.pollTimer);
    }
  }

  initPlayer(videoEl) {
    if (!window.videojs) return;

    const player = window.videojs(videoEl, { fluid: true });
    player.src({
      src: videoEl.dataset.playlistUrl,
      type: "application/x-mpegURL",
    });
    if (!this.players) this.players = [];
    this.players.push(player);
  }

  formatSize(bytes) {
    if (bytes >= 1024 * 1024) {
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }
    return `${Math.round(bytes / 1024)} KB`;
  }
}
